export default "/* components.css — gereserveerd voor modals/cards/knoppen (nog niet uitgesplitst) */\n"